export class RsyncResult {
    syncId = -1;
    targetOperation = -1;
    identityCode = "";
    userCd = -1;
    buknCd = -1;
    nyukyokeiyakuNo = -1;
}
